import * as base from './base';
import { log } from './log';
const produceUndefinedFuncError = (functionName) => new Error(`${functionName} was undefined`);
const produceUnsupportedClientError = () => new Error('unsupported client');
export const invokeAndroid = ({ functionName, params }) => {
    return new Promise((resolve, reject) => {
        const m2w = window.m2w;
        if (!m2w || !m2w[functionName]) {
            reject(produceUndefinedFuncError(functionName));
            return;
        }
        // 貌似安卓参数中传输不了js json对象
        if (params) {
            resolve(m2w[functionName](params));
        }
        else {
            resolve(m2w[functionName]());
        }
    });
};
export const invokeIos = ({ functionName, params }) => {
    return new Promise((resolve, reject) => {
        var _a;
        const callbackName = `WearableTemp${functionName}`;
        window[callbackName] = (value) => {
            window[callbackName] = undefined;
            resolve(value);
        };
        const webkit = window.webkit;
        if (!((_a = webkit === null || webkit === void 0 ? void 0 : webkit.messageHandlers) === null || _a === void 0 ? void 0 : _a[functionName])) {
            reject(produceUndefinedFuncError(functionName));
            return;
        }
        webkit.messageHandlers[functionName].postMessage({ callbackName, params });
    });
};
export const invoke = (config) => {
    if (base.isAndroid) {
        log(config);
        return invokeAndroid(config);
    }
    else if (base.isIos) {
        log(config);
        return invokeIos(config);
    }
    else {
        return Promise.reject(produceUnsupportedClientError());
    }
};
export default {
    invokeAndroid,
    invokeIos,
    invoke,
};
//# sourceMappingURL=data:application/json;base64,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